import type { ReactNode } from 'react';
import { Heading } from '@simplywallst/ui-core';
import { HeaderContainer, StyledInsightsLogo, LogoCol } from './styled';
import InsightsIcon from '@assets/images/logo/insights-icon.svg';
import { ArticleBreadcrumb } from './Breadcrumb';

interface Props {
  title: string;
  canonicalUrl: string;
  children?: ReactNode;
}

const Header = ({ title, children, canonicalUrl }: Props) => (
  <HeaderContainer>
    <div className="-mx-4 h-x5 bg-chart-02 px-3.5 pt-x1 lg:hidden">
      <InsightsIcon width={140} height={40} />
    </div>
    <LogoCol>
      <StyledInsightsLogo />
    </LogoCol>
    <div>
      <ArticleBreadcrumb articleTitle={title} canonicalUrl={canonicalUrl} />
      <Heading as="h1" color="black" typography="massStrong">
        {title}
      </Heading>
      {children}
    </div>
  </HeaderContainer>
);

export default Header;
